import { ClassNameProps, Column, makeClassName, Row, StyleProps } from "@hex-insights/core";
import { MediaLoadingPlaceholder, TextLineLoadingPlaceholder } from "./Base";
import styles from "./special.module.css";

export type SlimTimelineItemLoadingPlaceholderProps = Partial<ClassNameProps & StyleProps>;

export function SlimTimelineItemLoadingPlaceholder({ className, style }: SlimTimelineItemLoadingPlaceholderProps) {
	return (
		<Row
			justify="spaced-start"
			align="center"
			className={makeClassName(styles["slim-timeline-item"], className)}
			style={style}
		>
			<MediaLoadingPlaceholder style={{ width: "2.5rem", height: "2.5rem" }} />

			<Column justify="spaced-start" verticalSpacing="0.25rem" style={{ flexGrow: 1 }}>
				<TextLineLoadingPlaceholder className={styles["slim-timeline-item__heading"]} />
				<TextLineLoadingPlaceholder className={styles["slim-timeline-item__body"]} />
			</Column>
		</Row>
	);
}
